(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("globe2", [], factory);
	else if(typeof exports === 'object')
		exports["globe2"] = factory();
	else
		root["globe2"] = factory();
})(self, function() {
return 